<script>
    import {InfoWindow} from "vue2-google-maps";

    export default {
        extends: InfoWindow,
        props: {
            options: {
                default: () => {
                    return {
                        pixelOffset: {
                            width: 0,
                            height: -32,
                        }
                    }
                }
            }
        }
    }
</script>
